<template>
	<div v-if="visibility.overlay" class="dynamic-modal-wrapper">
		<div ref="overlay"
		     :aria-expanded="visibility.overlay"
		     :class="overlayClass"
		     :data-modal="name">

			<div v-if="visibility.modal"
			     ref="modal"
			     :class="modalClass">
				<slot />
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	// TODO: (DUMVUDATE-107) Transition animations don't work with teleport. So we need to look for a different implementation
	import {computed, ref} from 'vue';

	const props = withDefaults(defineProps<{
		id?: string;
		name?: string;
		classes?: string | string[];
		overlayTransition?: string;
		transition?: string;
	}>(), {
		classes: 'modal-wrapper--container',
		overlayTransition: 'modal-wrapper',
	});

	const overlayClass = ref('modal-wrapper--overlay');
	const visibility = ref({
		modal: true,
		overlay: true,
	});

	const modalClass = computed(() => {
		return ['modal-wrapper', props.classes];
	});
</script>
